const banners = document.querySelectorAll(".banners");

if (banners) {
  banners.forEach(bnrs => {
    const slides = bnrs.querySelectorAll("a");
    if (slides.length>0) {
      slides[0].classList.add('active');
    }

    if (slides && slides.length >1){
      durationSlider(slides);
    }
  });
}


function durationSlider(slides) {
  
  var listItems = slides.length;
  var count = 0;
  
  setInterval(function () {
    
    count += 1;
    if (count >= listItems) {
      count = 0;
    }
    [].forEach.call(slides, function (el) {
      el.classList.remove("active");
    });
    slides[count].classList.add('active');

  }, 8000);

}

